import {emptyValidator, formValidator} from "../../validators";
// blacklist validation added
const blackListValidationStatus = {
    blkReferance: {
        validators: [emptyValidator()],
        name: "Employee/Vehicle",
    },
    blkType: {
        validators: [emptyValidator()],
        name: "Type",
    },
    // blkDescription: {
    //     validators: [emptyValidator()],
    //     name: "Description",
    // },
    blkCategory: {
        validators: [emptyValidator()],
        name: "Category",
    },
    blkFrom: {
        validators: [emptyValidator()],
        name: "From Date",
    },
    blkTo: {
        validators: [emptyValidator()],
        name: "To Date",
    },

};

export const blackListValidation = (blackList) => {
    return formValidator(blackList, blackListValidationStatus);
}
